import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';

import AutoSignin from '@/features/auth/components/auto-signin';
import { SIGNIN_REDIRECT_URL_KEY } from '@/features/auth/config/oidc';

const LoginPage = () => {
  const { isAuthenticated } = useAuth();

  const handleBeforeSignin = useCallback(() => {
    window.sessionStorage.setItem(SIGNIN_REDIRECT_URL_KEY, import.meta.env.VITE_APP_EXCHANGE_URL);
  }, []);

  if (isAuthenticated) {
    window.location.assign(import.meta.env.VITE_APP_EXCHANGE_URL);
    return null;
  }

  return <AutoSignin onBeforeSignin={handleBeforeSignin} />;
};
LoginPage.displayName = 'LoginPage';

export default LoginPage;
